import { ForwardedRef, forwardRef, InputHTMLAttributes } from 'react';
import { StyledSelect } from './Select.styled';

export type SelectProps = InputHTMLAttributes<HTMLSelectElement> & {
  id: string;
  options: { label: string; value: string }[];
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  title?: string;
  sizes?: string;
  disabled?: boolean;
  variant?: string;
  innerRef?: ForwardedRef<HTMLSelectElement>;
};

const Select: React.FC<SelectProps> = forwardRef<
  HTMLSelectElement,
  SelectProps
>(
  (
    {
      id,
      options,
      onChange,
      onBlur,
      placeholder,
      title,
      sizes,
      disabled,
      value,
      variant,
      defaultValue
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref
  ) => (
    <StyledSelect
      id={id}
      aria-label={id}
      defaultValue={defaultValue}
      disabled={disabled}
      onChange={onChange}
      onBlur={onBlur}
      sizes={sizes}
      ref={ref}
      title={title}
      value={value}
      variant={variant}
    >
      {placeholder && <option hidden>{placeholder}</option>}
      {options.map((option, i) => (
        <option
          aria-label={`${id}_${option.value}`}
          key={i}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </StyledSelect>
  )
);

Select.displayName = 'Select';

export default Select;
